import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

enum GTMEvent {
    LISTING_ARCHITECT_CTA = "listing_architect_cta"
}

export enum GTMEventAction {
    VIEW = "view",
    CLICK = "click"
}

export const hitGtmArchitectCtaEvent = (action: GTMEventAction) => {
    hitGoogleTagManager({
        event: GTMEvent.LISTING_ARCHITECT_CTA,
        cta_action: action
    });
};
